import { useContext, useRef, useEffect } from 'react';
import { ItemTreeContext } from './ItemTreeContext.js';
import { jsx } from 'react/jsx-runtime';

function ItemTreeNode(props) {
  const {
    children,
    ...data
  } = props;
  const context = useContext(ItemTreeContext);
  if (!context) {
    throw new Error('ItemTreeNode rendered outside of an ItemTree');
  }
  const {
    parentList,
    indexRef,
    onUpdate
  } = context;
  const index = indexRef.current;
  const itemRef = useRef({
    children: [],
    data: data
  });
  const childIndexRef = useRef(0);
  useEffect(() => {
    const item = itemRef.current;
    parentList.splice(index, 0, item);
    return () => {
      parentList.splice(parentList.indexOf(item), 1);
      onUpdate();
    };
    // This hook should only run on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dataEntries = Object.entries(data).flat();
  useEffect(() => {
    itemRef.current.data = data;
    onUpdate();
    // This hook should only run when the data for the item has been updated.
    // React does not detect a change in length of the dependency array, so we
    // have to pass the length of the data as an explicit dependency.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEntries.length, ...dataEntries]);
  const childContext = {
    parentList: itemRef.current.children,
    indexRef: childIndexRef,
    onUpdate: context.onUpdate
  };
  ++indexRef.current;
  childIndexRef.current = 0;
  return /*#__PURE__*/jsx(ItemTreeContext.Provider, {
    value: childContext,
    children: children
  });
}

export { ItemTreeNode };
